import React, {createContext, useContext, useEffect, useState} from 'react'
import loadable from '@loadable/component'

// Lazy load SearchModal - only needed when user clicks search button
const SearchModal = loadable(() => import('../components/search-modal'), {
    ssr: false
})

const SearchModalContext = createContext()

export const useSearchModal = () => useContext(SearchModalContext);

export const SearchModalProvider = ({ children }) => {
    const [isSearchModalOpen, setSearchModalOpen] = useState(false);
    const [searchPlaceholder, setSearchPlaceholder] = useState(null);

    const openSearchModal = (placeholder = null) => {
        setSearchPlaceholder(placeholder);
        setSearchModalOpen(true);
    };
    const closeSearchModal = () => setSearchModalOpen(false);

    // Listen for the GDI drawer-link event so shortcode-driven search links
    // open the SearchModal.
    useEffect(() => {
        if (typeof window === 'undefined') return undefined
        const handler = (e) => {
            if (e?.detail?.drawer === 'search') openSearchModal()
        }
        window.addEventListener('gdi:openDrawer', handler)
        return () => window.removeEventListener('gdi:openDrawer', handler)
    }, []);

    return (
        <SearchModalContext.Provider value={{ isSearchModalOpen, openSearchModal, closeSearchModal }}>
            {children}
            <SearchModal 
                isSearchOpen={isSearchModalOpen} 
                onSearchClose={closeSearchModal}
                searchPlaceholder={searchPlaceholder}
            />
        </SearchModalContext.Provider>
    );
};
